import { render, staticRenderFns } from "./EditorLayoutSection.vue?vue&type=template&id=08b60571&"
import script from "./EditorLayoutSection.vue?vue&type=script&lang=js&"
export * from "./EditorLayoutSection.vue?vue&type=script&lang=js&"
import style0 from "./EditorLayoutSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports